import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/MatriSingInSignUp.css";

const MatriSingInSignUp = ({ open, onClose }) => {
  const [showSignIn, setShowSignIn] = useState(false);
  const [uniqueCode, setUniqueCode] = useState("");
  const navigate = useNavigate();

  if (!open) return null;

  const handleSignUp = () => {
    onClose();
    navigate("/matrimonial-register");
  };

  const handleSubmit = () => {
    console.log("Unique Code:", uniqueCode);
    // 👉 API call / validation logic here
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="close-btn" onClick={onClose}>×</button>

        <h2>{showSignIn ? "Sign In" : "Welcome to Bhandhan Sutra"}</h2>

        {!showSignIn ? (
          <div className="button-group">
            <button className="primary-btn" onClick={() => setShowSignIn(true)}>
              Sign In
            </button>

            <button className="secondary-btn" onClick={handleSignUp}>
              Sign Up
            </button>
          </div>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter Unique Code"
              value={uniqueCode}
              onChange={(e) => setUniqueCode(e.target.value)}
              className="input-field"
              autoFocus
            />

            <div className="button-group">
              <button
                className="primary-btn"
                onClick={handleSubmit}
                disabled={!uniqueCode}
              >
                Submit
              </button>

              <button
                className="secondary-btn"
                onClick={() => setShowSignIn(false)}
              >
                Back
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MatriSingInSignUp;
